import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalVar } from '../../globals/global-var';
import { CheckinService } from '../../services/checkin.service';
import { TokenService } from '../../services/token.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginForm = this.fb.group({
    userId: ['', Validators.required],
    password: ['', Validators.required],
  });


  constructor(private checkinService: CheckinService, private tokenService: TokenService, public globalVar: GlobalVar, private router: Router, private fb: FormBuilder) {
    if (globalVar.loggedIn == true) {
      this.router.navigate(['/home']);
    }
  }

  ngOnInit(): void {
  }

  postLogin(loginData: any) {

    this.checkinService.logout();

    this.tokenService.postLoginApi(loginData).subscribe(
      result => {
        this.globalVar.loggedIn = (result.token !== null);
        sessionStorage.setItem('authSystem_token', result.token);

      },
      err => {
        alert(JSON.stringify(err.error));
      },
      () => {
        this.tokenService.getMemberApi().subscribe(
          result => {           
            this.globalVar.mine = result;
            sessionStorage.setItem('authSystem_mine', JSON.stringify(result));
          },
          err => {
            alert(JSON.stringify(err.error));
          },
          () => {
            this.router.navigate(['/home']);
            console.log(this.globalVar.mine);
          }
        );
      }
    )
  } 

}
